import {
  FETCH_ACTIONS,
  FETCH_ACTIONS_SUCCESS,
  FETCH_ACTIONS_ERROR,
  FETCH_TV_CONSOLES,
  FETCH_TV_CONSOLES_SUCCESS,
  FETCH_TV_CONSOLES_ERROR,
  FETCH_TV_ACTIONS,
  FETCH_TV_ACTIONS_SUCCESS,
  FETCH_TV_ACTIONS_ERROR,
  FETCH_POINTS,
  FETCH_POINTS_SUCCESS,
  FETCH_POINTS_ERROR,
  SAVE_ACTIONS,
  SAVE_ACTIONS_SUCCESS,
  SAVE_ACTIONS_ERROR,
  SAVE_TV_ACTIONS,
  SAVE_TV_ACTIONS_SUCCESS,
  SAVE_TV_ACTIONS_ERROR,
  TOGGLE_NOTIFICATION_POINT,
  TOGGLE_NOTIFICATION_POINT_SUCCESS,
  TOGGLE_NOTIFICATION_POINT_ERROR,
  TOGGLE_POINT_EDITING_STATE,
  SAVE_NOTIFICATION_POINT,
  SAVE_NOTIFICATION_POINT_SUCCESS,
  SAVE_NOTIFICATION_POINT_ERROR,
  CONFIRM_NOTIFICATION_POINT_CODE,
  CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS,
  CONFIRM_NOTIFICATION_POINT_CODE_ERROR,
  RESET_NOTIFICATION_POINT_CODE_VALIDATION,
  SEND_NOTIFICATION_POINT_CODE,
  SEND_NOTIFICATION_POINT_CODE_SUCCESS,
  SEND_NOTIFICATION_POINT_CODE_ERROR,
  TOGGLE_CONFIRMATION_CODE_POPUP,
  RESET_ERROR,
  FETCH_REQUEST,
  FETCH_REQUEST_SUCCESS,
  FETCH_REQUEST_ERROR,
  SAVE_REQUEST,
  SAVE_REQUEST_SUCCESS,
  SAVE_REQUEST_ERROR,
} from './constants';

import {
  initNotificationPoints,
  togglePointEditingState,
  updateNotificationPointValue,
  setCodeValidity,
  resetNotificationPointCodeValidation,
  toggleSavingStatus,
  toggleCheckingStatus,
  toggleCodeSendingStatus,
  toggleConfirmationCodePopup,
  changeTogglingStatusOfNotificationPoint,
  toggleNotificationPoint,
} from '../../common';

import homePointsReducer from './containers/HomeNotificationPoints/reducer';
import { CONTAINER_NAME } from './containers/HomeNotificationPoints/actions';

const initialState = {
  isActionsFetching: false,
  isActionsSaving: false,
  isPointsFetching: false,
  isRequestFetching: true,
  isRequestSaving: false,
  actions: null,
  tvConsoles: {
    isFetching: false,
    error: null,
    data: null,
  },
  tvActions: {},
  points: null,
  accountConvergent: null,
  request: null,
  error: null,
  actionsFetchingError: null,
  pointsFetchingError: null,
  requestFetchingError: null,
};

export default function (state = initialState, action) {
  if (action.CONTAINER_NAME === CONTAINER_NAME) {
    return {
      ...state,
      homePoints: homePointsReducer(state.homePoints, action),
    };
  }
  switch (action.type) {
    case FETCH_ACTIONS:
      return {
        ...state,
        isActionsFetching: true,
      };
    case FETCH_ACTIONS_SUCCESS:
      return {
        ...state,
        isActionsFetching: false,
        actionsFetchingError: null,
        actions: action.data,
      };
    case FETCH_ACTIONS_ERROR:
      return {
        ...state,
        isActionsFetching: false,
        actionsFetchingError: action.error,
        actions: null,
      };
    case FETCH_TV_CONSOLES:
      return {
        ...state,
        tvConsoles: {
          isFetching: true,
          error: null,
          data: null,
        },
      };
    case FETCH_TV_CONSOLES_SUCCESS:
      return {
        ...state,
        tvConsoles: {
          isFetching: false,
          error: null,
          data: action.data,
        },
      };
    case FETCH_TV_CONSOLES_ERROR:
      return {
        ...state,
        tvConsoles: {
          isFetching: false,
          error: action.error,
          data: null,
        },
      };
    case FETCH_TV_ACTIONS:
      return {
        ...state,
        tvActions: {
          ...state.tvActions,
          [action.tvConsoleGuid]: {
            isFetching: true,
            fetchingError: null,
            data: null,
          },
        },
      };

    case FETCH_TV_ACTIONS_SUCCESS:
      return {
        ...state,
        tvActions: {
          ...state.tvActions,
          [action.tvConsoleGuid]: {
            isFetching: false,
            fetchingError: null,
            data: action.data,
          },
        },
      };
    case FETCH_TV_ACTIONS_ERROR:
      return {
        ...state,
        tvActions: {
          ...state.tvActions,
          [action.tvConsoleGuid]: {
            isFetching: false,
            fetchingError: action.error,
            data: null,
          },
        },
      };
    case FETCH_POINTS:
      return {
        ...state,
        isPointsFetching: true,
      };
    case FETCH_POINTS_SUCCESS:
      return initNotificationPoints({
        ...state,
        isPointsFetching: false,
        pointsFetchingError: null,
        points: action.data,
      });
    case FETCH_POINTS_ERROR:
      return {
        ...state,
        isPointsFetching: false,
        pointsFetchingError: action.error,
        points: null,
      };
    case FETCH_REQUEST:
      return {
        ...state,
        isRequestFetching: true,
      };
    case FETCH_REQUEST_SUCCESS:
      return {
        ...state,
        isRequestFetching: false,
        requestFetchingError: null,
        request: action.data,
      };
    case FETCH_REQUEST_ERROR:
      return {
        ...state,
        isRequestFetching: false,
        requestFetchingError: action.error,
        request: null,
      };
    case SAVE_ACTIONS:
      return {
        ...state,
        isActionsSaving: true,
      };
    case SAVE_ACTIONS_SUCCESS:
      return {
        ...state,
        actions: action.data,
        isActionsSaving: false,
      };
    case SAVE_ACTIONS_ERROR:
      return {
        ...state,
        isActionsSaving: false,
        error: action.error,
      };
    case SAVE_TV_ACTIONS:
      return {
        ...state,
        tvActions: {
          ...state.tvActions,
          [action.tvConsoleGuid]: {
            isSaving: true,
            savingError: null,
            data: state.tvActions[action.tvConsoleGuid].data,
          },
        },
      };
    case SAVE_TV_ACTIONS_SUCCESS:
      return {
        ...state,
        tvActions: {
          ...state.tvActions,
          [action.tvConsoleGuid]: {
            isSaving: false,
            savingError: false,
            data: action.data,
          },
        },
      };
    case SAVE_TV_ACTIONS_ERROR:
      return {
        ...state,
        tvActions: {
          ...state.tvActions,
          [action.tvConsoleGuid]: {
            isSaving: false,
            savingError: action.error,
            data: state.tvActions[action.tvConsoleGuid].data,
          },
        },
      };
    case TOGGLE_NOTIFICATION_POINT:
      return changeTogglingStatusOfNotificationPoint(state, action.data, true);
    case TOGGLE_NOTIFICATION_POINT_SUCCESS:
      return toggleNotificationPoint(state, action.data);
    case TOGGLE_NOTIFICATION_POINT_ERROR:
      return changeTogglingStatusOfNotificationPoint({
        ...state,
        error: action.error,
      }, action.data, false);
    case TOGGLE_POINT_EDITING_STATE:
      return togglePointEditingState(state, action.data);
    case SAVE_NOTIFICATION_POINT:
      return toggleSavingStatus(state, action.data, true);
    case SAVE_NOTIFICATION_POINT_SUCCESS:
      return initNotificationPoints(
        togglePointEditingState(
          updateNotificationPointValue(state, action.data),
          {
            type: action.data.type,
            isEditing: false,
          },
        ),
      );
    case SAVE_NOTIFICATION_POINT_ERROR:
      return toggleSavingStatus({
        ...state,
        error: action.error,
      }, action.data, false);
    case CONFIRM_NOTIFICATION_POINT_CODE:
      return toggleCheckingStatus(state, action.data, true);
    case CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS:
      return initNotificationPoints(setCodeValidity(state, action.data, false));
    case CONFIRM_NOTIFICATION_POINT_CODE_ERROR:
      return toggleCheckingStatus(
        setCodeValidity(state, action.data, true),
        action.data,
        false,
      );
    case RESET_NOTIFICATION_POINT_CODE_VALIDATION:
      return resetNotificationPointCodeValidation(state, action.data);
    case SEND_NOTIFICATION_POINT_CODE:
      return toggleCodeSendingStatus(state, action.data, true);
    case SEND_NOTIFICATION_POINT_CODE_SUCCESS:
      return toggleCodeSendingStatus(state, action.data, false);
    case SEND_NOTIFICATION_POINT_CODE_ERROR:
      return toggleCodeSendingStatus({
        ...state,
        error: action.error,
      }, action.data, false);
    case TOGGLE_CONFIRMATION_CODE_POPUP:
      return toggleConfirmationCodePopup(state, action.data);
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case SAVE_REQUEST:
      return {
        ...state,
        isRequestSaving: true,
      };
    case SAVE_REQUEST_SUCCESS:
      return {
        ...state,
        request: {
          ...state.request,
          ...action.data,
          isSuccess: true,
        },
        isRequestSaving: false,
      };
    case SAVE_REQUEST_ERROR:
      return {
        ...state,
        isRequestSaving: false,
        error: action.error,
        request: {
          ...state.request,
          isSuccess: false,
        },
      };
    default:
      return state;
  }
}
